import { z } from 'zod';

export const AuditSchema = z.object({
  // Timestamps básicos ya definidos en tu proyecto
  createdAt: z.any(),
  updatedAt: z.any().nullable().optional(),
  deletedAt: z.any().nullable().optional(), // Para Soft Deletes

  // Trazabilidad de Usuarios (Crítico para Salones)
  createdBy: z.string(), // UID del usuario que creó el registro
  updatedBy: z.string().nullable().optional(), // UID del último que editó
  deletedBy: z.string().nullable().optional(), // UID de quien eliminó
});

export type Audit = z.infer<typeof AuditSchema>;
